import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { Button, Card, CardBody } from "reactstrap";
import PersonalAddClientModal from "../Modals/Agents/PersonalAddClientModal";
import { errorHandler, showToast } from "../../../../helper-methods";
import Swal from "sweetalert2";
import {
  addUpdateClientsForWebsitePage,
  getAgentWebsiteDetail,
  saveDomainDetailForAgentWebsite,
} from "../../../../http/http-calls";
import WebsiteLaunchedModal from "./WebsiteLaunchedModal";

const PersonalWebsiteSetp4 = (
  { manageLoadingState, setIsFormSubmitted },
  ref
) => {
  const [addClientModal, setAddClientModal] = useState({
    isOpen: false,
    data: null,
  });

  const [agentWebsiteDetails, setAgentWebsiteDetails] = useState({});

  const [websiteLaunchedModal, setWebsiteLaunchedModal] = useState({
    isOpen: false,
    data: null,
  });
  //   const toggle = (isOpen = false, data = false) => setModal({ isOpen, data });

  const [manageClientsList, setManageClientsList] = useState([]);

  const _toggleAddClientModal = (isOpen = false, data = null) => {
    // console.log("length: ", manageClientsList?.length);
    if (isOpen && manageClientsList?.length >= 8 && !data) {
      errorHandler({ reason: "Can only add maximum 8 clients" });
      return;
    }

    setAddClientModal({ isOpen, data });
  };
  const _togglewebsiteLaunchedModal = (isOpen = false, data = null) => {
    setWebsiteLaunchedModal({ isOpen, data });
  };
  const _getAllClientsList = async () => {
    try {
      const res = await getAgentWebsiteDetail();
      console.log("12345 ", { res });

      const newManageClientsList =
        res?.agentWebsite?.manageClients?.map((each) => ({
          id: Date.now() + Math.random(),
          clientName: each?._agentClient?._client
            ? each?._agentClient?.name?.full
            : each?._agentClient?.companyName,
          clientId: each?._agentClient,
          position: each?.position,
          description: each?.description,
          logo: each?._agentClient?.logo || "",
        })) || [];

      setManageClientsList(newManageClientsList);
    } catch (err) {
      errorHandler(err);
      console.log({ err });
    }
  };

  const _getAgentWebsiteDetails = async () => {
    try {
      const res = await getAgentWebsiteDetail();

      if (res?.agentWebsite) {
        setAgentWebsiteDetails(res?.agentWebsite);
      }
    } catch (err) {
      errorHandler(err);
    }
  };

  const _removeClient = (id) => {
    const newManageClientsList = [...manageClientsList];

    const clientIndex = newManageClientsList?.findIndex(
      (each) => each?.id === id
    );

    if (clientIndex > -1) {
      newManageClientsList.splice(clientIndex, 1);
      console.log({ newManageClientsList });
    }
    setManageClientsList(newManageClientsList);
  };

  const _removeClientAlert = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to remove this client.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, remove it!",
    }).then((result) => {
      if (result.isConfirmed) {
        _removeClient(id);
      }
    });
  };

  //   const _addClient = () => {
  //     if (manageClientsList?.length > 8) {
  //       errorHandler({ reason: "max. 8 clients can be added" });
  //       return;
  //     }

  //   };

  const _onSubmit = async () => {
    try {
      manageLoadingState("stepLoading", true);

      const payload = manageClientsList?.map((each) => ({
        _agentClient: each?.clientId,
        position: each?.position,
        description: each?.description,
      }));

      console.log({ payload });

      const apiPayload = {
        manageClients: payload,
      };
      const res = await addUpdateClientsForWebsitePage(apiPayload);
      console.log({ res });
      showToast("Clients added successfully", "success");

      // for auto deployment
      if (
        agentWebsiteDetails?.isAutoGeneratedAwsRoute53 &&
        agentWebsiteDetails?.websiteDeployementProcessStatus === "Pending"
      ) {
        // email not verified yet
        if (!agentWebsiteDetails?.isEmailVerified) {
          errorHandler(
            "Email not verfied, please verify your email from step 2 to launch website."
          );
          manageLoadingState("stepLoading", false);
          _getAllClientsList();
          setIsFormSubmitted(true);
          return;
        }

        const clientPayload = {
          domainName: agentWebsiteDetails?.domainName,
          // domainName: "testing.closewise-surge.click",
          domainProvider: agentWebsiteDetails?.domainProvider,
          isAutoGeneratedAwsRoute53:
            agentWebsiteDetails?.isAutoGeneratedAwsRoute53,
        };

        console.log({ clientPayload });
        // save api call
        await saveDomainDetailForAgentWebsite(clientPayload);
      }

      manageLoadingState("stepLoading", false);
      // showToast("Website Created Successfully", "success");
      _getAllClientsList();
      setIsFormSubmitted(true);
      _togglewebsiteLaunchedModal(true);
    } catch (err) {
      errorHandler(err);
      console.log({ err });
      manageLoadingState("stepLoading", false);
      setIsFormSubmitted(false);
    }
  };

  useImperativeHandle(ref, () => ({
    _onSubmit,
  }));

  useEffect(() => {
    _getAllClientsList();
    _getAgentWebsiteDetails();
  }, []);
  return (
    <>
      <Card>
        <CardBody>
          <div className="text-center">
            <h1 className="fs-18 mb-2">Manage Clients</h1>
            <p>(You can add a maximum of 8 clients)</p>
          </div>
          <Button
            color="primary"
            size="md"
            className="ml-auto d-block"
            onClick={() => _toggleAddClientModal(true, null)}
          >
            Add Client
          </Button>

          <div className="manageClientWrapper">
            {manageClientsList?.length ? (
              manageClientsList?.map((each) => (
                <div className="manageList" key={each?.id}>
                  <div className="clientImage">
                    <img
                      src={
                        each?.logo
                          ? each?.logo
                          : require("../../../../assets/img/placeholder-img.png")
                              .default
                      }
                      alt="client"
                    />
                  </div>

                  <div className="clientInfo">
                    <h2>{each?.clientName}</h2>
                    <p>{each?.position}</p>
                    <p>{each?.description}</p>
                  </div>
                  <div className="actionManage">
                    <Button
                      color="link"
                      onClick={() => _toggleAddClientModal(true, each)}
                    >
                      <img
                        src={
                          require("../../../../assets/img/pencil.svg").default
                        }
                        alt="edit"
                      />
                    </Button>
                    <Button
                      color="link"
                      onClick={() => _removeClientAlert(each?.id)}
                    >
                      <img
                        src={
                          require("../../../../assets/img/deleteIcon.svg")
                            .default
                        }
                        alt="delete"
                      />
                    </Button>
                  </div>
                </div>
              ))
            ) : (
              <p className="d-flex justify-content-center">
                There is no data to display
              </p>
            )}
          </div>
        </CardBody>
      </Card>

      <PersonalAddClientModal
        isOpen={addClientModal?.isOpen}
        data={addClientModal?.data}
        toggle={_toggleAddClientModal}
        manageClientsList={manageClientsList}
        setManageClientsList={setManageClientsList}
      />

      <WebsiteLaunchedModal
        isOpen={websiteLaunchedModal?.isOpen}
        toggle={_togglewebsiteLaunchedModal}
        agentWebsiteDetails={agentWebsiteDetails}
      />
    </>
  );
};

export default forwardRef(PersonalWebsiteSetp4);
